import { getDrpInfo, getDrpMonthAmount, drpSign } from '@/api/extension'
const state = {
  drpInfo: {
    amount: 0,
    termList: [],
    resAmt: 0,
    planPayAt: '',
    reliefFeeList: []
  },
  drpResult: {
    amount: 0,
    term: 0
  }
}
const mutations = {
  'SET_DRP_INFO' (state, payload) {
    state.drpInfo = payload;
  },
  'SET_DRP_RESULT' (state, payload) {
    state.drpResult = payload
  }
}
const actions = {
  getDrpInfo ({ commit }, payload) {
    return getDrpInfo({
      applyId: payload
    }).then(data => {
      commit('SET_DRP_INFO', data)
      return Promise.resolve()
    })
  },
  getDrpMonthAmount ({ state, commit }, payload) {
    return getDrpMonthAmount(payload).then(data => {
      const obj = Object.assign({}, state.drpInfo, data)
      commit('SET_DRP_INFO', obj)
      return Promise.resolve()
    })
  },
  drpSign ({ commit }, payload) {
    return drpSign(payload).then(data => {
      commit('SET_DRP_RESULT', data)
      return Promise.resolve()
    })
  }
}
export default {
  state,
  mutations,
  actions
}
